import React, { useState } from 'react'
import InquiryForm from './InquiryForm';

function VisaAssistance() {



const countries = [
  { name: "Afghanistan", flag: "AF", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Algeria", flag: "DZ", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Argentina", flag: "AR", link:"https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Australia", flag: "AU", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Austria", flag: "AT", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Azerbaijan", flag: "AZ", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Bahrain", flag: "BH", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Bangladesh", flag: "BD", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Belgium", flag: "BE", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Bosnia & Herzegovina", flag: "BA", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Brazil", flag: "BR", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Bulgaria", flag: "BG", link: "/country/bulgaria" },
  { name: "Canada", flag: "CA", link: "/country/canada" },
  { name: "China", flag: "CN", link: "/country/china" },
  { name: "Cuba", flag: "CU", link: "/country/cuba" },
  { name: "Czech Republic", flag: "CZ", link: "/country/czech-republic" },
  { name: "Brunei Darussalam", flag: "BN", link: "/country/brunei" },
  { name: "Denmark", flag: "DK", link: "/country/denmark" },
  { name: "Egypt", flag: "EG", link: "/country/egypt" },
  { name: "Eritrea", flag: "ER", link: "/country/eritrea" },
  { name: "Ethiopia", flag: "ET", link: "/country/ethiopia" },
  { name: "Finland", flag: "FI", link: "/country/finland" },
  { name: "France", flag: "FR", link: "/country/france" },
  { name: "Germany", flag: "DE", link: "/country/germany" },
  { name: "Greece", flag: "GR", link: "/country/greece" },
  { name: "Holy See (Vatican)", flag: "VA", link: "/country/vatican" },
  { name: "Hong Kong", flag: "HK", link: "/country/hong-kong" },
  { name: "Hungary", flag: "HU", link: "/country/hungary" },
  { name: "India", flag: "IN", link: "/country/india" },
  { name: "Indonesia", flag: "ID", link: "/country/indonesia" },
  { name: "Iran", flag: "IR", link: "/country/iran" },
  { name: "Iraq", flag: "IQ", link: "/country/iraq" },
  { name: "Italy", flag: "IT", link: "/country/italy" },
  { name: "Japan", flag: "JP", link: "/country/japan" },
  { name: "Jordan", flag: "JO", link: "/country/jordan" },
  { name: "Kazakhstan", flag: "KZ", link: "/country/kazakhstan" },
  { name: "Kenya", flag: "KE", link: "/country/kenya" },
  { name: "Kuwait", flag: "KW", link: "/country/kuwait" },
  { name: "Kyrgyzstan", flag: "KG", link: "/country/kyrgyzstan" },
  { name: "Lebanon", flag: "LB", link: "/country/lebanon" },
  { name: "Lesotho", flag: "LS", link: "/country/lesotho" },
  { name: "Libya", flag: "LY", link: "/country/libya" },
  { name: "Malaysia", flag: "MY", link: "/country/malaysia" },
  { name: "Mauritius", flag: "MU", link: "/country/mauritius" },
  { name: "Morocco", flag: "MA", link: "/country/morocco" },
  { name: "Myanmar", flag: "MM", link: "/country/myanmar" },
  { name: "Nepal", flag: "NP", link: "/country/nepal" },
  { name: "Netherlands", flag: "NL", link: "/country/netherlands" },
  { name: "Nigeria", flag: "NG", link: "/country/nigeria" },
  { name: "North Korea", flag: "KP", link: "/country/north-korea" },
  { name: "Norway", flag: "NO", link: "/country/norway" },
  { name: "Oman", flag: "OM", link: "/country/oman" },
  { name: "Palestine", flag: "PS", link: "/country/palestine" },
  { name: "Poland", flag: "PL", link: "/country/poland" },
  { name: "Portugal", flag: "PT", link: "/country/portugal" },
  { name: "Qatar", flag: "QA", link: "/country/qatar" },
  { name: "Romania", flag: "RO", link: "/country/romania" },
  { name: "Russia", flag: "RU", link: "/country/russia" },
  { name: "Saudi Arabia", flag: "SA", link: "/country/saudi-arabia" },
  { name: "Singapore", flag: "SG", link: "/country/singapore" },
  { name: "Somalia", flag: "SO", link: "/country/somalia" },
  { name: "South Africa", flag: "ZA", link: "/country/south-africa" },
  { name: "South Korea", flag: "KR", link: "/country/south-korea" },
  { name: "Spain", flag: "ES", link: "/country/spain" },
  { name: "Sri Lanka", flag: "LK", link: "/country/sri-lanka" },
  { name: "Tajikistan", flag: "TJ", link: "/country/tajikistan" },
  { name: "Thailand", flag: "TH", link: "/country/thailand" },
  { name: "Tunisia", flag: "TN", link: "/country/tunisia" },
  { name: "Turkey", flag: "TR", link: "/country/turkey" },
  { name: "Turkmenistan", flag: "TM", link: "/country/turkmenistan" },
  { name: "United Arab Emirates", flag: "AE", link: "/country/uae" },
  { name: "United Kingdom", flag: "GB", link: "/country/united-kingdom" },
  { name: "Ukraine", flag: "UA", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "United States", flag: "US", link:"https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Uzbekistan", flag: "UZ", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" },
  { name: "Vietnam", flag: "VN", link: "https://falcondestinations.com/wp-content/uploads/2014/12/Afghanistan.pdf" }
];

const [showAll, setShowAll] = useState(false);
     const [InquiryFormOpen, setInquiryFormOpen] = useState(false);
 
  

const visibleCountries = showAll ? countries : countries.slice(0, 8);
  return (
    <div>
      <InquiryForm isOpen={InquiryFormOpen} setIsOpen={setInquiryFormOpen} />

          <div
            className="container-fluid bg-primary py-5 mb-5 hero-header"
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0.856), rgba(79, 79, 79, 0.801)), url(${process.env.PUBLIC_URL}/assets/img/destination-4.jpg)`,
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            Visa Assistance
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Visa Assistance
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Service Start */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          
          <h1 className="mb-5">Visa Assistance</h1>
          <h6 className="section-title bg-white text-center text-primary px-3">
          We provide visa assistance for the following countries.
          </h6>
        </div>
        <div className="row g-4">

{visibleCountries.map((item, index) => (
//   <div key={index}>
//     {item.flag} {item.name}
//   </div>

<>
  <div key={index} className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                   <p>
             <img
  src={`https://flagsapi.com/${item.flag}/flat/64.png`}
  alt={item.name}
/>
                </p>
                <h5>{item.name}</h5>
                 <a
                    target="_blank"
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                    onClick={() => setInquiryFormOpen(true)}
                  >
                   Inquire Now
                  </a>
              </div>
          
            </div>
          </div>

</>
))}
        
        {!showAll && (
  <div className="text-center mt-4">
    <button
      className="btn btn-sm btn-primary px-3"
      onClick={() => setShowAll(true)}
    >
      See More
    </button>
  </div>
)}
          
        </div>
      </div>
    </div>
    
    </div>
  )
}

export default VisaAssistance